import React from 'react'
import axios from 'axios';
import { GoSearch } from 'react-icons/go';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSearchStore } from '../../stores/search.store';


export default function SearchBar ({onSearch}) {

  const [allCategories, setAllCategories] = React.useState([]);

  const title = useSearchStore(state => state.title);
  const setTitle = useSearchStore(state => state.setTitle);

  const type = useSearchStore(state => state.type);
  const setType = useSearchStore(state => state.setType);

  const setStoreDate = useSearchStore(state => state.setDate);

  // use mindate as far in the past as possible
  const [date, setDate] = React.useState(new Date(0));

  
  React.useEffect(() => {
    // The categories name is a custom taxonomy called "course_category"
    axios.get('/wp-json/wp/v2/course_category')
    .then((response) => {
      setAllCategories(response.data);
    })
    .catch((error) => {
      console.log(error);
    })
  }, []);

  return (
    <div className='grid md:grid-cols-3 grid-cols-1 gap-4 border-2 border-gray-100 md:rounded-full rounded-xl shadow-lg bg-white 
                    p-5 px-6 md:px-12 pr-24 relative w-full'>
      <div className=''>
        <label htmlFor="nameSearch" className="font-bold text-sm text-gray-700 tracking-wider">
          Course Title 
        </label>
        <input type="text" id="nameSearch" placeholder="Which course are you looking for?"
        className='border-none w-full outline-none'
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        ></input>
      </div>  
      <div className='md:border-l-[2px] border-gray-400/30 md:pl-4'>
        <label htmlFor="typeSearch" className="font-bold text-sm text-gray-700 tracking-wider">
          Course Type
        </label>
        <select id="typeSearch" className='border-none w-full outline-none'
        value={type}
        onChange={(e) => setType(e.target.value)}
        >
          <option value="all">All</option> 
          {allCategories.map((category, index) => (
            <option value={category.name} 
            key={index}>{category.name}</option>
          ))}
        </select>  
      </div>

      <div className='md:border-l-[2px] border-gray-400/30 md:pl-4'>
        <label htmlFor="dateSearch" className="font-bold text-sm text-gray-700 tracking-wider">
          Date
        </label>
        <DatePicker
          id="dateSearch"
          selected={ 
            date === null ? null :
            date.getTime() === new Date(0).getTime() ? null : date
          }
          onChange={(date) => {setDate(date); setStoreDate(date)}}
          dateFormat="dd/MM/yyyy"
          className='border-none w-full outline-none'
          />

      </div>

      <div className="absolute right-4 md:top-1/2 md:transform md:-translate-y-1/2 bottom-4 md:bottom-auto">
        <button className="bg-black text-white px-4 py-2 rounded-full h-16 w-16 flex items-center justify-center text-[30px]"
        onClick={() => onSearch(title, type, date)}
        >
          <GoSearch className="inline-block" />
        </button>
      </div>
        
    </div>
  )
}
